import script from "./pro2biz.vue?vue&type=script&lang=js"
export * from "./pro2biz.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__